<template>
    <div class="animated fadeIn">
        <b-container fluid class="p-0">
            <b-row>
                <b-col sm="12" md="8" class="my-2">
                    <b-card no-body class=""  v-if="!isOrderingDisabled">
                        <b-card-header header-class="dark-header">
                            <span class="font-weight-bold text-white">Digital Orders</span>
                        </b-card-header>
                        <b-card-body>
                            
                            <div  >
                                <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                                    <p class="mb-0">Online Pickup Orders</p>
                                    <c-switch
                                            color="warning"
                                            v-model="model.AllowOrderPickup"

                                            @click="updateAllowance('TOGO', model.AllowOrderPickup)"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </div>
                                <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                                    <p class="mb-0">Kiosk Pickup Orders</p>
                                    <c-switch
                                            color="warning"
                                            v-model="model.AllowKioskOrdering"

                                            @click="updateAllowance('KIOSK', model.AllowKioskOrdering)"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </div>
                                <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                                    <p class="mb-0">Dine in Orders</p>
                                    <c-switch
                                            color="warning"
                                            v-model="model.AllowOrderDinein"
                                            @click="updateAllowance('DINEIN', model.AllowOrderDinein)"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </div>
                                <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                                    <p class="mb-0">Delivery Orders</p>
                                    <c-switch
                                        color="warning"
                                        @click="updateAllowance('DELIVERY', model.AllowOrderDelivery)"
                                        v-model="model.AllowOrderDelivery"
                                        label variant="3d"  dataOn="on" dataOff="off"/>
                                </div>
                                <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                                    <p class="mb-0">Kiosk Order Proof of Payment at Pickup</p>
                                    <c-switch
                                        color="warning"
                                        @click="updateAllowance('PROOF', model.myKioskOrderProofStep)"
                                        v-model="model.myKioskOrderProofStep"
                                        label variant="3d"  dataOn="on" dataOff="off"/>
                                </div>
                                <hr/>
                                <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                                    <p class="mb-0">Collect Emails from My Customers with Consent (CDP)</p>
                                    <c-switch
                                            color="warning"
                                            v-model="model.CDP"

                                            @click="updateAllowance('CDP', model.CDP)"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </div>
                                <hr/>
                                <b-row class="  d-sm-flex">
                                            <b-input-group
                                                :class="readonlyPaySrouces ? 'remove-border-styling' : ''"
                                                prepend-html='<div class="d-flex h-100 py-2">Other Pay Sources</div>'
                                            >
                                                <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
                                                <b-form-tags
                                                id="tags-component-select"
                                                v-model="chosenOtherPaySources"
                                                @input="onOtherPaySourcesChange"
                                                size="lg"
                                                placeholder="Required"
                                                :disabled="readonlyPaySrouces"
                                                add-on-change
                                                no-outer-focus
                                                >
                                                <template
                                                    v-slot="{
                                                    tags,
                                                    inputAttrs,
                                                    inputHandlers,
                                                    disabled,
                                                    removeTag,
                                                    }"
                                                >
                                                    <ul
                                                    v-if="tags && tags.length > 0"
                                                    class="mt-1 list-inline d-inline-block mb-2 d-flex flex-row justify-content-center align-items-center align-content-center"
                                                    >
                                                    <li
                                                        v-for="tag in tags"
                                                        :key="tag"
                                                        class="list-inline-item"
                                                    >
                                                        <b-form-tag
                                                        @remove="removeTag(tag)"
                                                        :title="tag"
                                                        :disabled="disabled"
                                                        :variant="
                                                        readonlyPaySrouces == false ? 'warning' : 'white'
                                                        "
                                                        >{{ tag }}</b-form-tag
                                                        >
                                                    </li>
                                                    </ul>
                                                    <b-form-select
                                                    v-bind="inputAttrs"
                                                    v-on="inputHandlers"
                                                    :disabled="
                                                        disabled ||
                                                        ( otherPaySources.length === 0) || readonlyPaySrouces
                                                    "
                                                    :class="
                                                        disabled ||
                                                        ( otherPaySources.length === 0) || readonlyPaySrouces
                                                        ? 'd-none'
                                                        : 'd-flex'
                                                    "
                                                    :options="otherPaySources"
                                                    >
                                                    <template #first>
                                                        <!-- This is required to prevent bugs with Safari -->
                                                        <option disabled value="">Select Payment Source...</option>
                                                    </template>
                                                    </b-form-select>
                                                </template>
                                                </b-form-tags>

                                                <b-input-group-append>
                                                <b-button
                                                    v-if="readonlyPaySrouces == false"
                                                    @click="updateOtherPaySources"
                                                    variant="success"
                                                    size="sm"
                                                    >Save Changes</b-button
                                                >
                                                </b-input-group-append>
                                                <b-button
                                                    v-if="readonlyPaySrouces == true"
                                                    class="mt-2 mr-3 pl-0"
                                                    @click="
                                                        () => {
                                                        readonlyPaySrouces = false;
                                                        }
                                                    "
                                                    variant="link"
                                                    >Edit
                                                </b-button>
                                            </b-input-group>
                                            
                                    </b-row>
                                <hr/>
                                <div class="mb-3">
                                    <b-input-group :class="!editTaxMode ? 'deactivePrepend' : ''" prepend="Tax Rate (%)">
                                        <template v-slot:append>
                                            <b-btn class="text-decoration-none" :variant="editTaxMode ? 'success' : 'link'" @click="editTaxRate">
                                                <span class="link" v-if="!editTaxMode">Edit</span>
                                                <span v-else>Apply</span>
                                            </b-btn>
                                        </template>
                                        <b-form-input class="text-center" :class="!editTaxMode ? 'removeBorder' : ''" :disabled="!editTaxMode" type="number" v-model="model.TaxRate"/>
                                    </b-input-group>
                                </div>

                                
                                <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                                    <p class="mb-0">Collect Tax on Applied Credit (Comp & Discount)</p>
                                    <c-switch
                                            color="warning"
                                            v-model="model.CollectTaxOnCredit_NAN_Alc"

                                            @click="updateAllowance('CollectTaxOnCredit_NAN_Alc', model.CollectTaxOnCredit_NAN_Alc)"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </div>
                                <hr/>
                                <div class="mb-3">
                                    <b-input-group :class="!editTaxAlcoholMode ? 'deactivePrepend' : ''" prepend="Alcohol Tax Rate (%)">
                                        <template v-slot:append>
                                            <b-btn class="text-decoration-none" :variant="editTaxAlcoholMode ? 'success' : 'link'" @click="editTaxRateAlcohol">
                                                <span v-if="!editTaxAlcoholMode">Edit</span>
                                                <span v-else>Apply</span>
                                            </b-btn>
                                        </template>
                                        <b-form-input class="text-center" :class="!editTaxAlcoholMode ? 'removeBorder' : ''" :disabled="!editTaxAlcoholMode" type="number" v-model="model.alcoholTaxRate"/>
                                    </b-input-group>
                                </div>
                                <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                                    <p class="mb-0">Collect Alcohol Tax on Applied Credit (Comp & Discount)</p>
                                    <c-switch
                                            color="warning"
                                            v-model="model.CollectTaxOnCredit_Alc"

                                            @click="updateAllowance('CollectTaxOnCredit_Alc', model.CollectTaxOnCredit_Alc)"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </div>
                                <hr/>
                                <div>
                                    <b-input-group :class="!editServerTipRate ? 'deactivePrepend' : ''" prepend="Server Tip Out Rate (%)">
                                        <template v-slot:append>
                                            <b-btn class="text-decoration-none" :variant="editServerTipRate ? 'success' : 'link'" @click="editTipRate">
                                                <span class="link" v-if="!editServerTipRate">Edit</span>
                                                <span v-else>Apply</span>
                                            </b-btn>
                                        </template>
                                        <numeric-input
                                            no-seprator
                                            class="text-center"
                                            :class="!editServerTipRate ? 'removeBorder' : ''"
                                            :disabled="!editServerTipRate"
                                            v-model="model.ServerTipOutRate"
                                        />
                                    </b-input-group>
                                </div>
                                <div>
                                    <hr/>
                                    <h5 class="font-weight-bold text-dark text-center">QR Code</h5>
                                    <div class="d-flex flex-column flex-md-row justify-content-between">
                                        <div class="border-md-right col-12 col-md-6 text-center d-flex flex-column  align-items-center align-content-center qrCode">
                                            <p class="mb-0">Pay First</p>
                                            <p class="mb-0">(Pickup | Delivery | Quick-Service Dine In)</p>
                                            <div v-if="QRCode1" class="d-flex flex-column" id="'QRCODE1WRAPPER">
                                                <vue-qr :correctLevel="3" :logoSrc="srcQR1" :dotScale="1" :text="QRCode1" :size="200"></vue-qr>
                                                <vue-qr class="d-none" :correctLevel="3" ref="QRCODE1WRAPPER" :logoSrc="srcQR1" :dotScale="1" :text="QRCode1" :size="1300"></vue-qr>
                                                <div style="color: lightseagreen" @click="downloadImage('QRCODE1WRAPPER')" class="text-link cursor-pointer">Save as</div>
                                            </div>
                                            <p style="margin-top:100px" class="text-muted" v-else>
                                                Select "Show Link" button below <br/> to load this QR Code image.
                                            </p>
                                        </div>
                                        <div class="col-12 col-md-6 text-center qrCode d-flex flex-column align-items-center align-content-center">
                                            <p class="mb-0">Pay After Served</p>
                                            <p class="mb-0">(Full-Service Dine In)</p>
                                            <div v-if="QRCode2">
                                                <vue-qr :correctLevel="3" :logoSrc="srcQR2" :dotScale="1" :text="QRCode2" :size="200"></vue-qr >
                                                <vue-qr class="d-none" :correctLevel="3" ref="QRCODE2WRAPPER" :logoSrc="srcQR2" :dotScale="1" :text="QRCode2" :size="1300"></vue-qr>
                                                <div style="color: lightseagreen" @click="downloadImage('QRCODE2WRAPPER')" class="text-link cursor-pointer">Save as</div>
                                            </div>
                                            <p style="margin-top:100px" class="text-muted" v-else>QR Code image does not exist <br/> since DINE IN is not enabled.</p>
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <h5 class="text-center font-weight-bold">Online Ordering Link</h5>
                                <p class="text-justify text-muted">
                                    Add below menu link to your restaurant website and your business profile on Google for customers to place TO GO (pickup or delivery) orders.
                                </p>
                                <div class="d-flex flex-row justify-content-center align-items-center">
                                    <b-btn class="mx-1" variant="warning" @click="createToGoLink" :disabled="loading">
                                        <span class="text-white font-weight-bold">Show Link</span>
                                    </b-btn>
                                    <b-btn class="mx-1"
                                        v-if="shortUrl !== null"
                                        v-clipboard:copy="shortUrl"
                                        v-clipboard:success="onCopyUrl"
                                    >
                                        <span class="text-white font-weight-bold">Copy Link</span>
                                    </b-btn>
                                    <span class="small mx-1 font-weight-bold" style="color: #4700ff">{{copied}}</span>
                                </div>
                                <h4 class="mt-3 text-center font-weight-bold">{{shortUrl}}</h4>
                                <hr/>
                                <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                                    <p class="mb-0">Second Language Naming</p>
                                    <c-switch
                                    color="warning"
                                    v-model="model.AllowSecondLang"
                                    @click="updateAllowance('SECONDLANG', model.AllowSecondLang)"
                                    label variant="3d"  dataOn="on" dataOff="off"/>
                                </div>
                                <div>
                                    <div class="row d-flex justify-content-between align-items-center align-content-center">
                                        <div class="col-12">
                                            <b-input-group prepend="Second Language">
                                                <select class="form-control" v-model="model.SecondLang" @change="changeSecondLang">
                                                    <option></option>
                                                    <option value="Chinese">Chinese</option>
                                                    <option value="Spanish">Spanish</option>
                                                </select>
                                            </b-input-group>
                                        </div>
                                    </div>
                                </div>
                                <div class="pb-2 pt-4">
                                    <p class="mb-0 text-muted">
                                        Second language naming applies to food/drink names, food/drink comments, and modifier options.
                                    </p>
                                </div>
                            </div>
                        </b-card-body>
                        
                    </b-card>
                            
                    <b-card no-body :style="{'height':'fit-content !important'}">
                        <b-card-header header-class="dark-header">
                                <span class="font-weight-bold text-white" >Assets</span>
                                
                        </b-card-header>
                        <b-card-body class="">
                                <div class="pb-5">
                                    <div class="mt-2 mb-4">
                                        <h5 v-if="assetsList.length" class="font-weight-bold">Asset List</h5>
                                        <b-table-simple v-if="assetsList.length" striped borderless responsive class="asset-table">
                                            <b-thead>
                                                <b-tr class="bg-gray-300">
                                                    <b-th>Category</b-th>
                                                    <b-th class="asset-table-name">Name</b-th>
                                                    <b-th>Model</b-th>
                                                    <b-th>Serial Number</b-th>
                                                    <b-th >Warranty Exp Date</b-th>
                                                    <b-th >Type</b-th>
                                                    <b-th >IP Address</b-th>
                                                    <b-th ></b-th>

                                                </b-tr>
                                            </b-thead>
                                            <b-tbody>
                                                <b-tr v-for="(item,index) in assetsList" :key="index" @click="showEditAssets(item)" class="cursor-pointer" >
                                                    <b-td class="asset-table-cell">
                                                        <span>{{ item.AssetCategory }}</span>
                                                    </b-td>
                                                    <b-td class="asset-table-cell asset-table-name">
                                                        <span >{{item.AssetName}}</span>
                                                        
                                                    </b-td>
                                                    <b-td class="asset-table-cell">{{item.ModelNo}}</b-td>
                                                    <b-td class="asset-table-cell">
                                                        <span>{{ item.SerialNo }}</span>
                                                    </b-td>
                                                    <b-td class="asset-table-cell">
                                                        {{ getDateFormatted(item.WarrantyExpDate) }}
                                                    </b-td>
                                                    <b-td class="asset-table-cell">
                                                        {{ item.AssetType }}
                                                    </b-td>
                                                    <b-td class="asset-table-cell">
                                                        {{ item.IPAddress }}
                                                    </b-td>
                                                    <b-td class="asset-table-cell">
                                                        <font-awesome-icon
                                                            icon="pencil-alt"
                                                            class="cursor-pointer"
                                                             />
                                                    </b-td>

                                                </b-tr>
                                            </b-tbody>

                                        </b-table-simple>
                                        <b-btn @click="showAddAssets" variant="danger" class="asset-action-btn">
                                            Add Asset
                                            <font-awesome-icon icon="plus" class="align-middle mx-1"/>
                                        </b-btn>
                                    </div>

                                    <hr/>
                                    <b-btn v-if="!isSuperUser" href="https://www.menupoly.com/app/utility.apk" @click="()=>true" class="printer-apk-btn printer-apk-btn-left" >
                                        Download MENUPOLY Utility App (APK)
                                            <font-awesome-icon icon="download" />
                                        </b-btn>
                                    <div v-if="isSuperUser">
                                        <div class="my-3">
                                            <h5 v-if="kdsList.length" class="font-weight-bold">Kitchen Displays</h5>
                                            <b-table-simple v-if="kdsList.length" striped borderless responsive>
                                                <b-thead>
                                                    <b-tr class="bg-gray-300">
                                                        <b-th>Displaystation Name</b-th>
                                                    </b-tr>
                                                </b-thead>
                                                <b-tbody>
                                                    <b-tr v-for="(item) in kdsList">
                                                        <b-td>
                                                            <p class="mb-0">
                                                                <span>{{item.KDS}}
                                                                    <template class="mx-2" v-if="!item.CanBeDeleted">(Main)</template>
                                                                </span>
                                                                <font-awesome-icon icon="pencil-alt" class="align-middle mx-2 cursor-pointer" @click="showEditKDSModal(item)"/>
                                                            </p>
                                                        </b-td>
                                                    </b-tr>
                                                </b-tbody>

                                            </b-table-simple>
                                            <b-btn @click="showKDSModal" variant="danger">
                                                Add Displaystation
                                                <font-awesome-icon icon="plus" class="align-middle mx-1"/>
                                            </b-btn>
                                        </div>
                                        <div :style="{position:'relative'}">
                                            <hr/>
                                            <h5 class="font-weight-bold">Printstations</h5>
                                            <b-table-simple v-if="printers.length" striped borderless responsive>
                                                <b-thead>
                                                    <b-tr class="bg-gray-300">
                                                        <b-th>Printstation Name</b-th>
                                                        <b-th>Used for</b-th>
                                                        <b-th>IP Address</b-th>
                                                        <b-th></b-th>
                                                        <b-th class="text-center">Print Enable</b-th>
                                                    </b-tr>
                                                </b-thead>
                                                <b-tbody>
                                                    <b-tr v-for="(item,index) in printers" :key="index">
                                                        <b-td>
                                                            <p class="mb-0" v-if="!item.editMode">
                                                                <span>{{item.PrinterName}}</span>
                                                            </p>
                                                            <b-input-group size="sm" v-else>
                                                                <template v-slot:append>
                                                                    <b-btn class="text-decoration-none" variant="success" @click="editPrinterName">
                                                                        <span class="link">Edit</span>
                                                                    </b-btn>
                                                                    <b-btn class="text-decoration-none" variant="danger" @click="cancelEdirPrinter(item)">
                                                                        <span class="link">Cancel</span>
                                                                    </b-btn>
                                                                </template>
                                                                <b-form-input class="text-center" type="text" v-model="item.PrinterName"/>
                                                            </b-input-group>
                                                        </b-td>
                                                        <b-td>
                                                            <span v-if="item.PrintTaskID === 1">Order Ticket</span>
                                                            <span v-else-if="item.PrintTaskID === 2">Customer Receipt</span>
                                                        </b-td>
                                                        <b-td>{{item.IPAddress}}</b-td>
                                                        <b-td>
                                                            <font-awesome-icon icon="pencil-alt" class="align-middle mx-2 cursor-pointer" @click="showEditMode(item)"/>
                                                        </b-td>
                                                        <b-td class="text-center">
                                                            <c-switch
                                                                    color="warning"
                                                                    v-model="item.activate"
                                                                    @click="UpdatePrinterStatus(item.PrinterID, item.activate)"
                                                                    label variant="3d"  dataOn="on" dataOff="off"/>
                                                        </b-td>
                                                    </b-tr>
                                                </b-tbody>

                                            </b-table-simple>
                                            <b-btn @click="showAddPrint" variant="danger">
                                                Add Printstation
                                                <font-awesome-icon icon="plus" class="align-middle mx-1"/>
                                            </b-btn>
                                            <b-btn href="https://www.menupoly.com/app/utility.apk" @click="()=>true" class="printer-apk-btn printer-apk-btn-right" >
                                                Download MENUPOLY Utility App (APK)
                                                <font-awesome-icon icon="download" />
                                            </b-btn>
                                        
                                            <hr/>
                                            <card-reader
                                                :items="cardReaders"
                                                :restaurantId="$store.state.selectedRestaurantId"
                                                @updateCardReaders="GetRestaurantPOSs"
                                            />
                                            
                                        </div>
                                    </div>
                                </div>
                        </b-card-body>
                    </b-card>
                </b-col>
                <b-col sm="12" md="8" class="my-2">
                    <b-card no-body class=""  v-if="!isOrderingDisabled">
                            <b-card-header header-class="dark-header">
                                <span class="font-weight-bold text-white">Security</span>
                            </b-card-header>
                            <b-card-body>
                                
                                <div  >
                                    <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                                        <p class="mb-0">Automatic User Logout After Inactivity Timeout</p>
                                        <c-switch
                                                color="warning"
                                                v-model="model.myAllowAutomaticLogout"

                                                @click="updateAllowance('AutoLogout', model.myAllowAutomaticLogout)"
                                                label variant="3d"  dataOn="on" dataOff="off"/>
                                    </div>
                                    <hr/>
                                    <div class="mb-3" v-if="model.myAllowAutomaticLogout">
                                        <b-input-group :class="!editAutoLogoutMode ? 'deactivePrepend' : ''" prepend="Auto Logout Inactivity Timeout (seconds)">
                                            <template v-slot:append>
                                                <b-btn class="text-decoration-none" :variant="editAutoLogoutMode ? 'success' : 'link'" @click="editAutoLogout">
                                                    <span v-if="!editAutoLogoutMode">Edit</span>
                                                    <span v-else>Apply</span>
                                                </b-btn>
                                            </template>
                                            <b-form-input class="text-center" :class="!editAutoLogoutMode ? 'removeBorder' : ''" :disabled="!editAutoLogoutMode" type="number" v-model="model.myAutomaticLogoutTimeThreshold"/>
                                        </b-input-group>
                                    </div>
                                    
                                </div>
                            </b-card-body>
                            
                        </b-card>
                </b-col>
            </b-row>

            <c-modal size="lg" centered v-model="editModalPrintName" :tag="false" title="Edit Printstation">
                <template>
                    <b-alert :show="errors.any()" variant="danger" class="px-4">
                        <ul class="m-0 px-1">
                            <li v-for="err in errors.all()" :key="err">{{err}}</li>
                        </ul>
                    </b-alert>
                    <b-input-group prepend="Printstation Name">
                        <b-form-input class="text-center" type="text" name="Printstation Name" v-validate="'required'" v-model="printModel.PrinterName"/>
                    </b-input-group>
                    <b-input-group prepend="Used For" class="mt-3">
                        <b-form-select
                            :options="usedForOptions"
                            v-model="printModel.PrintTaskID"
                            v-validate="'required'"
                
                            name="Used For"
                        />
                    </b-input-group>
                    <b-input-group prepend="IP Address" class="mt-3">
                        <b-form-input class="text-center" type="text" name="IP Address" v-validate="'required|IpAddress'" v-model="printModel.IPAddress"/>
                    </b-input-group>
                    <b-input-group prepend="Port Number" class="mt-3">
                            <b-form-input class="text-center" type="number" name="Port Number" v-validate="'required'" v-model="printModel.Port"/>
                        </b-input-group>
                </template>
                <template #actions>
                    <b-row class="flex-grow-1">
                        <b-col cols="4">
                            <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="editPrint">
                                Save changes
                                <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                            </b-btn>
                        </b-col>
                        <b-col cols="4">
                            <b-btn variant="danger" :disabled="loading" block class="text-nowrap" @click="deletePrintStation">
                                Delete Printstation
                            </b-btn>
                        </b-col>
                        <b-col cols="4">
                            <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="editModalPrintName = !editModalPrintName">
                                Cancel
                            </b-btn>
                        </b-col>
                    </b-row>
                </template>
            </c-modal>

            <c-modal centered v-model="addPrintModal" :tag="false" title="Create Printstation Name">
                <template>
                    <div>
                        <b-alert :show="errors.any()" variant="danger" class="px-4">
                            <ul class="m-0 px-1">
                                <li v-for="err in errors.all()" :key="err">{{err}}</li>
                            </ul>
                        </b-alert>
                        <b-input-group prepend="Printstation Name">
                            <b-form-input class="text-center" type="text" name="Printstation Name" v-validate="'required'" v-model="printModel.PrinterName"/>
                        </b-input-group>
                        <b-input-group prepend="Used For" class="mt-3">
                            <b-form-select
                                    :options="usedForOptions"
                                    v-model="printModel.PrintTaskID"
                                    v-validate="'required'"
                                    name="Used For"
                            />
                        </b-input-group>
                        <b-input-group prepend="IP Address" class="mt-3">
                            <b-form-input class="text-center" type="text" name="IP Address" v-validate="'required|IpAddress'" v-model="printModel.IPAddress"/>
                        </b-input-group>
                        <b-input-group prepend="Port Number" class="mt-3">
                            <b-form-input class="text-center" type="number" name="Port Number" v-validate="'required'" v-model="printModel.Port"/>
                        </b-input-group>
                    </div>
                </template>
                <template #actions>
                    <b-row class="flex-grow-1">
                        <b-col cols="6">
                            <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="addPrint">
                                Save change
                                <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                            </b-btn>
                        </b-col>
                        <b-col cols="6">
                            <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="addPrintModal = !addPrintModal">
                                Cancel
                            </b-btn>
                        </b-col>
                    </b-row>
                </template>
            </c-modal>

            <c-modal centered v-model="addKDSModal" :tag="false" title="Add Displaystation">
                <template>
                    <b-alert :show="errors.any()" variant="danger" class="px-4">
                        <ul class="m-0 px-1">
                            <li v-for="err in errors.all()" :key="err">{{err}}</li>
                        </ul>
                    </b-alert>
                    <b-input-group class="mb-0" prepend="Displaystation Name">
                        <b-form-input class="text-center" type="text" name="Displaystation Name" v-validate="'required'" v-model="kdsModel.KDSName"/>
                    </b-input-group>
                </template>
                <template #actions>
                    <b-row class="flex-grow-1">
                        <b-col cols="6">
                            <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="addKDS">
                                Create Displaystation
                                <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                            </b-btn>
                        </b-col>
                        <b-col cols="6">
                            <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="addKDSModal = !addKDSModal">
                                Cancel
                            </b-btn>
                        </b-col>
                    </b-row>
                </template>
            </c-modal>

            <c-modal v-model="deleteConfirmationPrinter" @submit="deletePrinterOK" :progressing="loading" :tag="false" centered title="Delete Printstation Confirmation" cancel-label="No, Never mind" confirm-label="Yes, Proceed with delete">
                <template>
                    <div class="mb-3">
                        Note: if this printstation is a target ticket printer for any food/drink item(s), deleting this printstation would leave those food/drink with no ticket printer target.
                    </div>
                    <div>
                        Do you still want to delete this printstation?
                    </div>
                </template>
            </c-modal>

            <c-modal :size="kdsModel.CanBeDeleted ? 'lg' : 'md'" centered v-model="editKDSModal" :tag="false" title="Edit Displaystation Name">
                <template>
                    <b-alert :show="errors.any()" variant="danger" class="px-4">
                        <ul class="m-0 px-1">
                            <li v-for="err in errors.all()" :key="err">{{err}}</li>
                        </ul>
                    </b-alert>
                    <p class="text-danger font-weight-bold" v-if="!kdsModel.CanBeDeleted">
                        Note: This is the main kitchen display system of this restaurant and cannot be deleted.
                    </p>
                    <b-input-group prepend="Displaystation Name">
                        <b-form-input class="text-center" type="text" name="Displaystation Name" v-validate="'required'" v-model="kdsModel.KDSName"/>
                    </b-input-group>
                </template>
                <template #actions>
                    <b-row class="flex-grow-1">
                        <b-col :cols="kdsModel.CanBeDeleted ? 4 : 6">
                            <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="editKDS">
                                Save changes
                                <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                            </b-btn>
                        </b-col>
                        <b-col v-if="kdsModel.CanBeDeleted" cols="4">
                            <b-btn variant="danger" :disabled="loading" block class="text-nowrap" @click="deleteKds">
                                Delete Displaystation
                            </b-btn>
                        </b-col>
                        <b-col :cols="kdsModel.CanBeDeleted ? 4 : 6">
                            <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="editKDSModal = !editKDSModal">
                                Cancel
                            </b-btn>
                        </b-col>

                    </b-row>
                </template>
            </c-modal>

            <c-modal v-model="deleteConfirmationKDS" @submit="deleteKDSOK" :progressing="loading" :tag="false" centered title="Delete Displaystation Confirmation" cancel-label="No, Never mind" confirm-label="Yes, Proceed with delete">
                <template>
                    <div class="mb-3">
                        Note: if this displaystation is target KDS (Kitchen Display System) for any food/drink item(s), deleting this displaystation would associate those food/drink item(s) with the main KDS by default.
                    </div>
                    <div>
                        Do you still want to delete this displaystation?
                    </div>
                </template>
            </c-modal>
            <addAssets   @hideWindow='hideAddAssets' :show="showAddAsset"/>
            <editAssets :item="editingItem"   @hideWindow='hideEditAssets' :show="showEditAsset"/>

        </b-container>
    </div>
</template>

<script>
    import { Switch as cSwitch } from '@/components/shared'
    import {attachTag, deleteUrl, getUrlShortener, urlShortner} from "../../lib/urlShortener";
    import validation from "../../mixins/validation";
    import CardReader from "../shared/cardReader";
    import VueQr from 'vue-qr'
    import QR1 from './QR1.jpg'
    import QR2 from './QR2.jpg'
    import NumericInput from "../shared/NumericInput";
    import CModal from "../shared/Cmodal";
    import addAssets from './addAssets.vue';
    import editAssets from './editAssets.vue';
    import * as types from '@/store/types'
    export default {
        name: "index",
        components: {
            CModal,
            CardReader,
            cSwitch,
            VueQr,
            NumericInput,
            addAssets,
            editAssets
        },
        mixins: [validation],
        data () {
            return {
                cardReaders: [],
                loading: false,
                editTaxMode: false,
                editServerTipRate: false,
                editTaxAlcoholMode: false,
                restaurantTax: null,
                bigQrCodeSrc: null,
                showQrCodeModal: false,
                model: {
                    AllowOrderDinein: false,
                    AllowOrderPickup: false,
                    AllowKioskOrdering: false,
                    AllowSecondLang: false,
                    AllowOrderDelivery: false,
                    CollectTaxOnCredit_NAN_Alc: false,
                    CollectTaxOnCredit_Alc: false,
                    CDP:false,
                    TaxRate: null,
                    alcoholTaxRate: null,
                    QRCodeDineIn: null,
                    QRCodeToGo: null,
                    SecondLang: null,
                    ServerTipOutRate: 0,
                    myAllowAutomaticLogout: false,
                    myAutomaticLogoutTimeThreshold: 90,
                    myKioskOrderProofStep: false
                },
                loadBtn: false,
                printers: [],
                editModalPrintName: false,
                copyPrintTaskID: null,
                deleteConfirmationPrinter: false,
                deleteConfirmationKDS: false,
                printModel: {
                    PrinterName: null,
                    PrinterID: null,
                    Port: null,
                    Inactive: null,
                    MAC: null,
                    PrintTaskID: null,
                    IPAddress: null
                },
                addPrintModal: false,
                usedForOptions: [
                    {text: 'Choose one of the items...', value: null},
                    {text: 'Order Ticket', value: 1},
                    {text: 'Customer Receipt', value: 2},
                ],
                kdsList: [],
                assetsList:[],
                addKDSModal: false,
                kdsModel: {
                    KDSName: null,
                    KDSID: null,
                    CanBeDeleted: true
                },
                editKDSModal: false,
                LongURL_TOGO: null,
                LongURL_DININ: null,
                LongURL_DELIVERY: null,
                Rebrandly_TOGO: null,
                Rebrandly_DINEIN: null,
                Rebrandly_DELIVERY: null,
                shortUrl: null,
                copied: null,
                serverPrinterIp: '',
                editPrinterServerIp: false,
                showErrorIp: false,
                QRCode1: '',
                QRCode2: '',
                srcQR1: QR1,
                srcQR2: QR2,
                showAddAsset:false,
                showEditAsset:false,
                editingItem:{},
                isOrderingDisabled:false,
                editAutoLogoutMode: false,
                otherPaySources: [],
                referenceOtherPaySources: [],
                chosenOtherPaySources: [],
                readonlyPaySrouces: true,
            }
        },
        
        metaInfo () {
            return {
                title: 'General settings'
            }
        },
        computed:{
            isSuperUser(){
                if(localStorage.getItem('ClientTypeID') == 2){
                    return true
                }
                return false
            },
          
        },
        created(){
            this.isOrderingDisabled = localStorage.getItem('AllOrderingDisabled') === "true"
        },
        updated(){
            this.isOrderingDisabled = localStorage.getItem('AllOrderingDisabled') === "true"
        },
        watch: {
            '$store.state.selectedRestaurantId': {
                handler: function (newVal) {
                    if (newVal && newVal !== null) {
                        let object = {
                            RestaurantID: newVal,
                            // UserID: localStorage.getItem('userID')
                        }
                        this.copied = null
                        this.shortUrl = null
                        //Get settings page options based on selected restaurant
                        this.GetRestaurantTax(object)
                        this.GetRestaurantAllowance(object)
                        this.GetRestaurantInfo(object)
                        this.GetRestaurantQRCode(object)
                        this.GetRestaurantPrinters(object)
                        this.GetRestaurantAssets(object)
                        this.GetRestaurantKDSs(object)
                        this.GetRestaurantOrderURL(object)
                        this.GetServerPrinterIP(object)
                        this.GetRestaurantQRCodes(object)
                        this.GetRestaurantPOSs()
                        this.GetOtherPaySource(object)
                        this.GetRestaurantOtherPaySources(object)
                    }
                },
                immediate: true
            }
        },
        methods: {
            GetOtherPaySource(object){
                let model = {...object}
                model.UserID = localStorage.getItem('userID')
                this.$api.getRestaurant.GetOtherPaySource(model).then(res => {
                    if(res.success){
                        if(res.results.length > 0){
                            this.referenceOtherPaySources = res.results
                            this.otherPaySources = res.results.map(item => item[1])
                        } else {
                            this.referenceOtherPaySources = []
                            this.otherPaySources = []
                        }
                    }
                })
            },
            GetRestaurantOtherPaySources(object){
                this.$api.getRestaurant.GetRestaurantProfile(object).then(res => {
                    if(res.success){
                        if(res.OtherPaySources && res.OtherPaySources.length > 0){
                            this.chosenOtherPaySources = res.OtherPaySources.map(item => item[1])
                        } else {
                            this.chosenOtherPaySources = []
                        }
                    }
                })
            },
            onOtherPaySourcesChange(){
            },
            updateOtherPaySources(){
                let otherPaySourceValue = 0

                this.referenceOtherPaySources.forEach(item => {
                    if(this.chosenOtherPaySources.includes(item[1])){
                        otherPaySourceValue += item[0]
                    }
                })

                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    UserID: localStorage.getItem('userID'),
                    OtherPaySource: otherPaySourceValue
                }

                this.$api.getRestaurant.UpdateOtherPaySource(model).then(res => {
                    if(res.success){
                        this.readonlyPaySrouces = true
                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            DeleteAsset(ikey){
                this.$api.getRestaurant.DeleteRestaurantAsset({IKey:ikey}).then(res=>{
                    if(res.success)
                        this.GetRestaurantAssets({RestaurantID: localStorage.getItem('selectedRestaurant'),})
                }).catch(err=>{
                    this.$showError(err)
                })
            },
            getDateFormatted(dateString){
                if(typeof(dateString) != "string" || dateString.length === 0){
                    return
                }
                
                const monthsArr = 
                ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                let date =  dateString.substring(0,dateString.indexOf(" "))
                date = date.split("/")
                let finalDate = "" +date[1]+ "-" + monthsArr[date[0].toString() -1]+ "-" + date[2]
                return finalDate


            },
            GetRestaurantTax (object) {
                this.$api.getRestaurant.GetRestaurantTax(object).then(res => {
                    if (res.success) {
                        this.restaurantTax = res.results
                        this.model.TaxRate = (res.results[1] * 100).toFixed(3)
                        this.model.alcoholTaxRate = (res.results[3] * 100).toFixed(3)
                    }
                })
            },
            GetRestaurantAssets(object){
            let obj = object
            obj.AssetCategory = ''
                this.$api.asset.Get(obj).then(res => {
                        this.assetsList = res.data.RestaurantAssets                   
                })

            },
            GetRestaurantAllowance (object) {
                this.$api.getRestaurant.GetRestaurantAllowance(object).then(res => {
                    if (res.success) {
                        this.model.AllowOrderDinein = res.results.AllowOrderDinein
                        this.model.AllowOrderPickup = res.results.AllowOrderPickup
                        this.model.AllowKioskOrdering = res.results.AllowKioskOrdering
                        this.model.AllowOrderDelivery = res.results.AllowOrderDelivery
                        this.model.AllowSecondLang = res.results.AllowSecondLang
                        this.model.SecondLang = res.results.SecondLang
                        this.model.CDP = res.results.CDP
                        this.model.CollectTaxOnCredit_Alc = res.results.CollectTaxOnCredit_Alc
                        this.model.CollectTaxOnCredit_NAN_Alc = res.results.CollectTaxOnCredit_NAN_Alc
                        this.model.ServerTipOutRate = res.results.ServerTipOutRate
                    }
                })
            },
            GetRestaurantInfo(object){
                this.$api.publicClient.GetRestaurantInfo(object).then(res => {
                    if (res.success) {
                        this.model.myAllowAutomaticLogout = res.results.myAllowAutomaticLogout
                        this.model.myAutomaticLogoutTimeThreshold = res.results.myAutomaticLogoutTimeThreshold
                        this.model.myKioskOrderProofStep = res.results.myKioskOrderProofStep
                        this.$store.commit(types.SET_AUTO_LOGOUT_TIMER_VALUE, this.model.myAutomaticLogoutTimeThreshold)
                        this.$store.commit(types.SET_INITIAL_AUTO_LOGOUT_TIMER, this.model.myAllowAutomaticLogout)
                    }
                })
            },
            editAutoLogout(){
                if(!this.editAutoLogoutMode){
                    this.editAutoLogoutMode = true
                } else {
                    if(this.model.myAutomaticLogoutTimeThreshold === null || this.model.myAutomaticLogoutTimeThreshold === ''){
                        this.$showError('Auto Logout Time Threshold must not be empty')
                    } else if(this.model.myAutomaticLogoutTimeThreshold < 10 || this.model.myAutomaticLogoutTimeThreshold > 3600){
                        this.$showError('Auto Logout Time Threshold must be greater than 10 and less than 3600')
                    } else {
                        this.updateRestaurantAutomatic_Logout_Time_Threshold()
                    }
                }
            },
            updateRestaurantAutomatic_Logout_Time_Threshold(){
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    Automatic_Logout_Time_Threshold: this.model.myAutomaticLogoutTimeThreshold,
                    UserID: localStorage.getItem('userID')
                }
                this.$api.getRestaurant.UpdateRestaurantAutomatic_Logout_Time_Threshold(object).then(res => {
                    if (!res.success) {
                        this.$showError(res.message)
                        //console.log("updateRestaurantAutomatic_Logout_Time_Threshold: ", this.model.myAutomaticLogoutTimeThreshold)

                    } else {
                        this.$store.commit(types.SET_AUTO_LOGOUT_TIMER_VALUE, this.model.myAutomaticLogoutTimeThreshold)
                    }
                    this.editAutoLogoutMode = false
                })
            },
            editTaxRate () {
                //edit tax rate
                if (!this.editTaxMode) {
                    this.editTaxMode = true
                } else {
                    if (this.model.TaxRate === null || this.model.TaxRate === '') {
                        this.$showError('Tax Rate must not be empty')
                    } else {
                        let object = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            Tax: this.model.TaxRate,
                            Tax_Type: 'NON_ALC'
                        }
                        this.$api.getRestaurant.UpdateRestaurantTax(object).then(res => {
                            if (res.success) {
                                this.editTaxMode = false
                            } else {
                                this.$showError(res.message)
                            }
                        })
                    }
                }
            },
            editTipRate () {
                //edit tax rate
                if (!this.editServerTipRate) {
                    this.editServerTipRate = true
                } else {
                    if (!this.model.ServerTipOutRate && this.model.ServerTipOutRate !== 0) {
                        this.$showError('Server Tip Out Rate must not be empty')
                    } else if (this.model.ServerTipOutRate > 100) {
                        this.$showError('Server Tip Out Rate must not be greather than 100')
                    } else {
                        let object = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            allowanceValue: this.model.ServerTipOutRate,
                            allowanceType: 'TIPOUTRATE'
                        }
                        this.$api.getRestaurant.UpdateRestaurantAllowance(object).then(res => {
                            if (res.success) {
                                this.editServerTipRate = false
                            } else {
                                this.$showError(res.message)
                            }
                        })
                    }
                }
            },
            editTaxRateAlcohol () {
                //edit tax rate alcohol
                if (!this.editTaxAlcoholMode) {
                    this.editTaxAlcoholMode = true
                } else {
                    if (this.model.alcoholTaxRate === null || this.model.alcoholTaxRate === '') {
                        this.$showError('alcohol Tax Rate must not be empty')
                    } else {
                        let object = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            Tax: this.model.alcoholTaxRate,
                            Tax_Type: 'ALC'
                        }
                        this.$api.getRestaurant.UpdateRestaurantTax(object).then(res => {
                            if (res.success) {
                                this.editTaxAlcoholMode = false
                            } else {
                                this.$showError(res.message)
                            }
                        })
                    }
                }
            },
            GetRestaurantQRCode (object) {
                this.$api.getRestaurant.GetRestaurantQRCode(object).then(res => {
                    if (res.success) {
                        this.model.QRCodeDineIn = res.results + '_QRCode_Dinein.jpg'
                        this.model.QRCodeToGo = res.results + '_QRCode_Togo.jpg'
                    }
                })
            },
            test (dataUrl) {
            },
            showBigQrCode (src) {
                //show qrcode in b-modal
                this.showQrCodeModal = true
                this.bigQrCodeSrc = src
            },
            updateAllowance (type, value) {
                //update 3 switches ( To Go orders + Dine in orders + order alarm sound play)
                if (type === 'TOGO') {
                    let data = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        AllowanceType: 'TOGO',
                        IsAllowance: value ? 0 : 1
                    }
                    this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(res => {
                        if (res.success) {
                        } else {
                            this.$showError(res.message)
                        }
                    })
                }
                else if (type === 'KIOSK') {
                    let data = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        AllowanceType: 'KIOSKORDERING',
                        IsAllowance: value ? 0 : 1
                    }
                    this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(res => {
                        if (res.success) {
                        } else {
                            this.$showError(res.message)
                        }
                    })
                }
                else if (type === 'DINEIN') {
                    let data = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        AllowanceType: 'DINEIN',
                        IsAllowance: value ? 0 : 1
                    }
                    this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(res => {
                        if (res.success) {
                        } else {
                            this.$showError(res.message)
                        }
                    })
                }
                else if (type === 'DELIVERY') {
                    let data = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        AllowanceType: 'DELIVERY',
                        IsAllowance: value ? 0 : 1
                    }
                    this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(res => {
                        if (res.success) {
                        } else {
                            this.$showError(res.message)
                        }
                    })
                }
                else if (type === 'CDP') {
                    let data = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        AllowanceType: 'CDP',
                        IsAllowance: value ? 0 : 1
                    }
                    this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(res => {
                        if (res.success) {
                        } else {
                            this.$showError(res.message)
                        }
                    })
                }
                else if (type === 'SECONDLANG') {
                    let data = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        AllowanceType: 'SECONDLANG',
                        IsAllowance: value ? 0 : 1,
                        AllowanceValue: this.model.SecondLang
                    }
                    this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(res => {
                        if (res.success) {
                        } else {
                            this.$showError(res.message)
                        }
                    })
                }
                else if (type === 'CollectTaxOnCredit_NAN_Alc') {
                    let data = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        AllowanceType: 'TAXCREDITNANALC',
                        AllowanceValue: value ? 0 : 1,
                    }
                    this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(res => {
                        if (res.success) {
                        } else {
                            this.$showError(res.message)
                        }
                    })
                }
                else if (type === 'CollectTaxOnCredit_Alc') {
                    let data = {
                        UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        AllowanceType: 'TAXCREDITALC',
                        AllowanceValue: value ? 0 : 1,
                    }
                    this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(res => {
                        if (res.success) {
                        } else {
                            this.$showError(res.message)
                        }
                    })
                }
                else if (type === 'AutoLogout') {
                    this.initialAutoLogoutTimer(value)

                    let data = {
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        AllowanceType: 'AUTOLOGOUT',
                        AllowanceValue: value ? 0 : 1,
                    }
                    this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(res => {
                        if (res.success) {
                        } else {
                            this.$showError(res.message)
                        }
                    })
                }
                else if (type === 'PROOF') {
                    let data = {
                        UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        AllowanceType: 'PROOF',
                        AllowanceValue: value ? 0 : 1,
                    }
                    this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(res => {
                        if (res.success) {
                        } else {
                            this.$showError(res.message)
                        }
                    })
                }
            },
            initialAutoLogoutTimer(value){//listened for in sidebarnav.vue
                this.$store.commit(types.SET_INITIAL_AUTO_LOGOUT_TIMER, !value)
            },
            changeSecondLang (e) {
                let lang = e.target.value
                let data = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    AllowanceType: 'SECONDLANG',
                    IsAllowance: this.model.AllowSecondLang ? 1 : 0,
                    AllowanceValue: lang
                }
                this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(res => {
                    if (res.success) {
                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            GetRestaurantPrinters (object) {
                this.$api.getRestaurant.GetRestaurantPrinters(object).then(res => {
                    if (res.success) {
                        this.printers = res.results.RestaurantPrinter
                        this.printers.forEach(item => {
                            if (item.Inactive === 0) {
                                item.activate = true
                            } else {
                                item.activate = false
                            }
                        })
                        
                    }
                })
            },
            showEditMode (item) {
                this.editModalPrintName = true
                if (item.PrintTaskID === 0) {
                    item.PrintTaskID = null
                }
                this.printModel = {...item}
                this.copyPrintTaskID = item.PrintTaskID
            },
            editPrint () {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    PrinterID: this.printModel.PrinterID,
                    PrinterName: this.printModel.PrinterName,
                    TaskID: this.printModel.PrintTaskID,
                    IPAddress: this.printModel.IPAddress,
                    Port: this.printModel.Port
                }
                this.$validator.validateAll().then(r => {
                    if (r) {
                        this.loading = true
                        this.$api.getRestaurant.UpdatePrinters(object).then(res => {
                            if (res.success) {
                                this.editModalPrintName = false
                                this.loading = false
                                let model = {
                                    RestaurantID: this.$store.state.selectedRestaurantId,
                                    // UserID: localStorage.getItem('userID')
                                }
                                this.GetRestaurantPrinters(model)
                            } else {
                                this.$showError(res.message)
                                this.loading = false
                            }
                        })
                    }
                })
            },
            UpdatePrinterStatus (PrinterID, Inactive) {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    PrinterID,
                    Inactive: Inactive === true ? 1 : 0
                }
                this.$api.getRestaurant.UpdatePrinterStatus(object).then(res => {
                    if (res.success) {
                        let model = {
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            // UserID: localStorage.getItem('userID')
                        }
                        this.GetRestaurantPrinters(model)
                    }
                })
            },
            showAddPrint () {
                this.addPrintModal = true
                this.printModel = {
                    PrinterName: null,
                    PrinterID: null,
                    Inactive: null,
                    MAC: null,
                    PrintTaskID: null,
                    IPAddress: null
                }
            },
            showAddAssets(){
                this.showAddAsset = true
            },
            showEditAssets(item){
                this.editingItem = item
                this.showEditAsset = true

            },
            hideAddAssets(){
                this.showAddAsset = false
                this.GetRestaurantAssets({RestaurantID: localStorage.getItem('selectedRestaurant')})
                this.GetRestaurantPrinters({RestaurantID: localStorage.getItem('selectedRestaurant')})
                this.GetRestaurantKDSs({RestaurantID: localStorage.getItem('selectedRestaurant')})
                this.GetRestaurantPOSs({RestaurantID: localStorage.getItem('selectedRestaurant')})
            },
            hideEditAssets(){
                this.editingItem = {}
                this.showEditAsset = false
                this.GetRestaurantAssets({RestaurantID: localStorage.getItem('selectedRestaurant'),})
            },
            addPrint () {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    PrinterName: this.printModel.PrinterName,
                    PrintTaskID: this.printModel.PrintTaskID,
                    IPAddress: this.printModel.IPAddress,
                    Port: this.printModel.Port,
                }
                this.$validator.validateAll().then(r => {
                    if (r) {
                        this.loading = true
                        this.$api.getRestaurant.CreateRestaurantPrinter(object).then(res => {
                            if (res.success) {
                                this.addPrintModal = false
                                this.loading = false
                                let model = {
                                    RestaurantID: this.$store.state.selectedRestaurantId,
                                    // UserID: localStorage.getItem('userID')
                                }
                                this.GetRestaurantPrinters(model)
                            } else {
                                this.$showError(res.message)
                                this.loading = false
                            }
                        })
                    }
                })
            },
            deletePrintStation () {
                if (this.copyPrintTaskID === 1) {
                    this.deleteConfirmationPrinter = true
                } else {
                    this.$showConfirm(undefined, 'Are you sure you want to delete this item?').then(() => {
                        this.deletePrinterOK()
                    })
                }
            },
            deletePrinterOK () {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    PrinterID: this.printModel.PrinterID,
                }
                this.loading = true
                this.$api.getRestaurant.DeletePrinter(object).then(res => {
                    if (res.success) {
                        this.loading = false
                        this.editModalPrintName = false
                        this.deleteConfirmationPrinter = false
                        let model = {
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            // UserID: localStorage.getItem('userID')
                        }
                        this.GetRestaurantPrinters(model)
                    } else {
                        this.editModalPrintName = false
                        this.loading = false
                    }
                })
            },
            
            GetRestaurantKDSs (object) {
                //get list of kds
                this.$api.getRestaurant.GetRestaurantKDSs(object).then(res => {
                    if (res.success) {
                        this.kdsList = res.results.RestaurantKDS
                    }
                })
            },
            showKDSModal () {
                //show pop up for create new kds
                this.kdsModel.KDSName = null
                this.kdsModel.KDSID = null
                this.addKDSModal = true
            },
            addKDS () {
                // cretae kds
                this.$validator.validateAll().then(res => {
                    if (res) {
                        let data = {
                            KDSName: this.kdsModel.KDSName,
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            // UserID: localStorage.getItem('userID')
                        }
                        this.loading = true
                        this.$api.getRestaurant.InsertKDSName(data).then(res => {
                            if (res.success) {
                                this.addKDSModal = false
                                this.loading = false
                                //update kds list
                                let KdsList = {
                                    RestaurantID: this.$store.state.selectedRestaurantId,
                                    // UserID: localStorage.getItem('userID')
                                }
                                this.GetRestaurantKDSs(KdsList)
                            }
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                })
            },
            deleteKds () {
                this.deleteConfirmationKDS = true
            },
            deleteKDSOK () {
                let data = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    KDSID: this.kdsModel.KDSID
                }
                this.loading = true
                this.$api.getRestaurant.UpdateDeleteKDS(data).then(res => {
                    if (res.success) {
                        //close edit pop up
                        this.editKDSModal = false
                        this.loading = false
                        this.deleteConfirmationKDS = false
                        //update kds list
                        let KdsList = {
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            // UserID: localStorage.getItem('userID')
                        }
                        this.GetRestaurantKDSs(KdsList)
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            showEditKDSModal (item) {
                //show pop up for create new kds
                this.kdsModel.KDSName = item.KDS
                this.kdsModel.KDSID = item.KDSID
                this.kdsModel.CanBeDeleted = item.CanBeDeleted
                this.editKDSModal = true
            },
            editKDS () {
                //edit kds
                this.$validator.validateAll().then(res => {
                    if (res) {
                        let data = {
                            KDSName: this.kdsModel.KDSName,
                            KDSID: this.kdsModel.KDSID,
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            // UserID: localStorage.getItem('userID')
                        }
                        this.loading = true
                        this.$api.getRestaurant.UpdateKDSName(data).then(res => {
                            if (res.success) {
                                this.editKDSModal = false
                                this.loading = false
                                //update kds list
                                let KdsList = {
                                    RestaurantID: this.$store.state.selectedRestaurantId,
                                    // UserID: localStorage.getItem('userID')
                                }
                                this.GetRestaurantKDSs(KdsList)
                            }
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                })
            },
            GetRestaurantOrderURL (object) {
                this.$api.getRestaurant.GetRestaurantOrderURL(object).then(res => {
                    if (res.success) {
                        this.LongURL_DELIVERY = res.results.LongURL_DELIVERY
                        this.LongURL_DININ = res.results.LongURL_DININ
                        this.LongURL_TOGO = res.results.LongURL_TOGO
                        this.Rebrandly_TOGO = res.results.Rebrandly_TOGO ? res.results.Rebrandly_TOGO : null
                        this.Rebrandly_DINEIN = res.results.Rebrandly_DINEIN ? res.results.Rebrandly_DINEIN : null
                        this.Rebrandly_DELIVERY = res.results.Rebrandly_DELIVERY ? res.results.Rebrandly_DELIVERY : null
                    }
                })
            },
            createToGoLink () {
                this.shortUrl = this.$config.websiteUrl + '/' + this.Rebrandly_TOGO
                
            },
            onCopyUrl (e) {
                this.copied = 'Copied'
            },
            UpdateRestaurantShortURLid (payload) {
                return this.$api.getRestaurant.UpdateRestaurantShortURLid(payload).then(res => {
                    if (res.success) {
                        let object = {
                            RestaurantID : this.$store.state.selectedRestaurantId,
                            // UserID: localStorage.getItem('userID')
                        }
                        this.GetRestaurantOrderURL(object)
                        return res
                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            validationIp (value) {
                if (!(value.match(/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/g))) {
                    return false
                } else {
                    return true
                }
            },
            GetServerPrinterIP (object) {
                this.$api.getRestaurant.GetServerPrinterIP(object).then(res => {
                    if (res.success) {
                        this.serverPrinterIp = res.results.serverPrinterIp
                    }
                })
            },
            GetRestaurantQRCodes (object) {
                this.$api.getRestaurant.GetRestaurantQRCodes(object).then(res => {
                    if (res.success) {
                        this.QRCode1 = res.results.QRCode1
                        this.QRCode2 = res.results.QRCode2
                    }
                })
            },
            GetRestaurantPOSs () {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    TableIKey: -1
                }
                return this.$api.getRestaurant.GetRestaurantPOSs(object).then(res => {
                    if (res.success) {
                        this.cardReaders = res.results
                    }
                })
            },
            UpdateRestaurantQRCode (QRCodeLink) {
                const object = {
                    RestaurantID : this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    QRCodeID: 1,
                    QRCodeLink
                }
                this.$api.getRestaurant.UpdateRestaurantQRCode(object).then(res => {
                    if (res.success) {
                        const model = {
                            RestaurantID : this.$store.state.selectedRestaurantId,
                            // UserID: localStorage.getItem('userID'),
                        }
                        this.GetRestaurantQRCodes(model)
                    }
                })
            },
            UpdateRestaurantPrinterServerIP () {
                if (!this.editPrinterServerIp) {
                    this.editPrinterServerIp = true
                } else {
                    if (this.serverPrinterIp !== '' && !this.validationIp(this.serverPrinterIp)) {
                        // this.$showError('PrinterServerIP is not valid')
                        this.showErrorIp = true
                    } else {
                        let data = {
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            // UserID: localStorage.getItem('userID'),
                            PrinterServerIP: this.serverPrinterIp
                        }
                        this.showErrorIp = false
                        this.$api.getRestaurant.UpdateRestaurantPrinterServerIP(data).then(res => {
                            if (res.success) {
                                this.editPrinterServerIp = false
                            }
                        })
                    }
                }
            },
            downloadImage (id) {
                if (id === 'QRCODE1WRAPPER') {
                    const largeImage = this.$refs.QRCODE1WRAPPER.$el
                    largeImage.style.display = 'block';
                    largeImage.style.width=200+"px";
                    largeImage.style.height=200+"px";
                    var url=largeImage.getAttribute('src');
                    var newTab = window.open();
                    newTab.document.body.innerHTML = `<img src=${url} width="500px" height="500px">`;
                } else {
                    const largeImage = this.$refs.QRCODE2WRAPPER.$el
                    largeImage.style.display = 'block';
                    var url=largeImage.getAttribute('src');
                    var newTab = window.open();
                    newTab.document.body.innerHTML = `
                    <div style="margin: auto" class="text-center w-100 d-flex flex-row justify-content-center align-content-center">
                        <img style="margin: auto" src=${url} width="500px" height="500px">
                    </div>`;
                }

            }
        }
    }
</script>

<style scoped lang="scss">
.remove-border-styling {
  .input-group-prepend {
    background: #fff !important;
    border: none !important;
  }
  .input-group-text {
    background: #fff !important;
    border: none !important;
  }
  .form-control {
    border: none !important;
    background-color: #ffff !important;
  }
  .custom-select {
    border: none !important;
    box-shadow: none !important;
    background: #fff;
  }
}
    .qrCode{
        img {
            cursor: pointer;
        }
    }
    .form-control:disabled, .form-control[readonly]{
        background: #fff !important;
    }
    .removeBorder{
        border: none !important;
    }
    .deactivePrepend{
        .input-group-prepend{
            background: #fff !important;
            border: none !important;
        }
        .input-group-text{
            background: #fff !important;
            border: none !important;
        }
    }
    .createLink{

    }
    .asset-table .asset-table-cell{
        word-break: break-word;
        overflow-wrap: anywhere;
    }
    @media (max-width: 575.98px){
        .asset-table{
            font-size: 0.8rem;
        }
        .asset-table th,
        .asset-table td{
            padding: 0.5rem 0.4rem;
        }
        .asset-table .asset-table-name{
            min-width: 9rem;
            white-space: nowrap;
            word-break: normal;
            overflow-wrap: normal;
        }
        .asset-action-btn,
        .printer-apk-btn{
            width: 100%;
            max-width: 100% !important;
            position: static !important;
            left: auto !important;
            right: auto !important;
            white-space: normal;
            margin-top: 0.5rem;
        }
    }
    .printer-apk-btn-left{
        position: absolute;
        left: 1.1rem;
        max-width: 40vw;
    }
    .printer-apk-btn-right{
        position: absolute;
        right: 0;
        max-width: 40vw;
    }
</style>
